import { useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import { Button } from "../../../components/button/Button";
import { ModalContext } from "../../../components/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileCsv,
  faFileExcel,
  faFilePdf,
} from "@fortawesome/free-solid-svg-icons";
import { exportFile, exportRequest } from "../../../redux/exportSlice";
import {
  hideNotification,
  showNotification,
} from "../../../redux/notificationSlice";
import { selectCurrentTab } from "../../../redux/queryBuilderSlice";
const ExportPopup = () => {
  const dispatch = useDispatch<AppDispatch>();
  const modalContext = useContext(ModalContext);
  const close = modalContext ? modalContext.close : () => {};

  const currQuery = useSelector(selectCurrentTab);
  const query = useSelector((state: RootState) => currQuery.query);
  const queryMode = useSelector((state: RootState) => currQuery.queryMode);
  const tabName = useSelector((state: RootState) => currQuery.tabName);
  const querySubType = useSelector(
    (state: RootState) => currQuery.querySubType,
  );
  const msrSelections = useSelector(
    (state: RootState) => currQuery.msrSelections,
  );

  const exportData = async (format: string) => {
    const fileName =
      (document.getElementById("file-name") as HTMLInputElement)?.value ||
      "export";
    const formData = new FormData();
    formData.append(
      "args",
      JSON.stringify([
        {
          isMap: queryMode === "Map" ? true : false,
          vizType: queryMode,
          ...(queryMode !== "Grid" && { subType: querySubType }),
          format: format,
          queryName: query?.name,
          noLimit: false,
          tabName: tabName,
          showFlattened: true,
          gridSorts:
            query?.gridSorts?.map((gridSort: any) => {
              return {
                colId: gridSort.colId,
                sort: gridSort.sort,
                levelUniqueName: gridSort.levelUniqueName,
                sortIndex: gridSort.sortIndex,
              };
            }) || [],
          ...(queryMode === "Map" && {
            mapOptions: {
              measureSelections: msrSelections,
              measureStyleCode:
                querySubType == "thematic" ? "TCVI" : "DDEFAULT",
            },
          }),
        },
      ]),
    );

    close();
    const fileUrl = await dispatch(
      exportRequest({ fileName, format, formData }),
    ).unwrap();
    if (!fileUrl) {
      alert("Failed to export file");
    } else {
      handleDownload(fileUrl);
    }
  };

  const handleDownload = async (fileUrl: string) => {
    try {
      dispatch(
        showNotification({
          message: "File is being downloaded",
          duration: 3000,
        }),
      );
      window.location.href = fileUrl;
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  return (
    <div className="dialog-container dialog-box-min filter-box">
      <div className="dialog-header"></div>
      <div className="dialog-title">
        <h3>Export As</h3>
      </div>
      <div className="dialog-body">
        <div className="input-group">
          <label htmlFor="file-name">File Name</label>
          <input type="text" id="file-name" className="input-field" />
        </div>
      </div>
      <div className="dialog-footer">
        <div className="apply-cancel">
          <Button
            color="primary"
            className="btn md"
            variant="solid"
            id="btn-excel"
            onClick={() => exportData("xlsx")}
          >
            <FontAwesomeIcon icon={faFileExcel} />
            Excel
          </Button>
          <Button
            color="primary"
            className="btn md"
            variant="solid"
            id="btn-csv"
            onClick={() => exportData("csv")}
          >
            <FontAwesomeIcon icon={faFileCsv} />
            CSV
          </Button>
          <Button
            color="primary"
            className="btn md"
            variant="solid"
            id="btn-pdf"
            onClick={() => exportData("pdf")}
          >
            <FontAwesomeIcon icon={faFilePdf} />
            PDF
          </Button>
          <Button
            color="primary"
            className="btn md"
            variant="outline"
            id="btn-close"
            onClick={close}
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ExportPopup;
